(window["webpackJsonpmeg_ui"] = window["webpackJsonpmeg_ui"] || []).push([["index~layout"],{

/***/ 145:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./src/utils/vue_types/index.js + 1 modules
var vue_types = __webpack_require__(0);

// EXTERNAL MODULE: external "classnames"
var external_classnames_ = __webpack_require__(2);
var external_classnames_default = /*#__PURE__*/__webpack_require__.n(external_classnames_);

// CONCATENATED MODULE: ./src/components/layout/utils.js
// 计算style方法
function computeStyle() {
  var style = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // 遍历获取style里面的属性，过滤没有值的属性
  var newStyle = {};

  for (var k in style) {
    if (style[k] !== null && style[k] !== undefined) {
      newStyle[k] = style[k];
    }
  }

  return newStyle;
}
// CONCATENATED MODULE: ./src/components/layout/Wrapper.jsx
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }




var Wrap = {
  name: 'meg-wrap',
  props: {
    classProps: vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].string, vue_types["a" /* default */].array]),
    horizontal: vue_types["a" /* default */].bool.def(false),
    height: vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].string, vue_types["a" /* default */].number]).def(null),
    width: vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].string, vue_types["a" /* default */].number]).def(null),
    flex: vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].string, vue_types["a" /* default */].number]).def(null)
  },
  computed: {
    _styleProps: function _styleProps() {
      return computeStyle({
        height: this.height,
        width: this.width,
        flex: this.flex
      });
    },
    _classProps: function _classProps() {
      return Array.isArray(this.classProps) ? this.classProps : [this.classProps];
    }
  },
  render: function render() {
    var h = arguments[0];
    return h("div", {
      style: this._styleProps,
      "class": external_classnames_default.a.apply(void 0, ["meg-wrap", {
        'meg-wrap-row': this.horizontal
      }].concat(_toConsumableArray(this._classProps)))
    }, [this.$slots.default]);
  }
};
/* harmony default export */ var Wrapper = (Wrap);
// CONCATENATED MODULE: ./src/components/layout/Header.jsx
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var baseCls = "meg-layout-header";
var Header = {
  name: baseCls,
  props: {
    height: vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].string, vue_types["a" /* default */].number]).def("null"),
    flex: vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].string, vue_types["a" /* default */].number]).def("null")
  },
  render: function render() {
    var h = arguments[0];
    var props = {
      props: _objectSpread(_objectSpread({}, this.$props), {}, {
        horizontal: true,
        classProps: [baseCls]
      })
    };
    return h(Wrapper, props, [this.$slots.logo && h("div", {
      "class": "".concat(baseCls, "-slot ").concat(baseCls, "-logo"),
      style: ""
    }, [this.$slots.logo]), this.$slots.title && h("div", {
      "class": "".concat(baseCls, "-slot ").concat(baseCls, "-title")
    }, [this.$slots.title]), this.$slots.menu && h("div", {
      "class": "".concat(baseCls, "-slot ").concat(baseCls, "-nav")
    }, [this.$slots.menu]), this.$slots.person && h("div", {
      "class": "".concat(baseCls, "-slot ").concat(baseCls, "-userinfo")
    }, [this.$slots.person])]);
  }
};
/* harmony default export */ var layout_Header = (Header);
// EXTERNAL MODULE: ./node_modules/babel-helper-vue-jsx-merge-props/index.js
var babel_helper_vue_jsx_merge_props = __webpack_require__(3);
var babel_helper_vue_jsx_merge_props_default = /*#__PURE__*/__webpack_require__.n(babel_helper_vue_jsx_merge_props);

// CONCATENATED MODULE: ./src/components/layout/Sider.jsx


function Sider_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Sider_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Sider_ownKeys(Object(source), true).forEach(function (key) { Sider_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Sider_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function Sider_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var Sider = {
  name: "meg-layout-sider",
  render: function render() {
    var h = arguments[0];
    var prefixCls = "meg-layout-sider";
    var props = {
      props: Sider_objectSpread({}, this.$attrs)
    };
    return h(Wrapper, babel_helper_vue_jsx_merge_props_default()([props, {
      "class": "".concat(prefixCls)
    }]), [this.$slots.default]);
  }
};
/* harmony default export */ var layout_Sider = (Sider);
// CONCATENATED MODULE: ./src/components/layout/Footer.jsx
function Footer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Footer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Footer_ownKeys(Object(source), true).forEach(function (key) { Footer_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Footer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function Footer_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var Footer = {
  name: "meg-layout-footer",
  props: {
    height: vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].string, vue_types["a" /* default */].number]).def("64px")
  },
  render: function render(h) {
    var props = {
      props: Footer_objectSpread(Footer_objectSpread({}, this.$props), {}, {
        classProps: "meg-layout-footer"
      })
    };
    return h(Wrapper, props, [this.$slots.default]);
  }
};
/* harmony default export */ var layout_Footer = (Footer);
// CONCATENATED MODULE: ./src/components/layout/Content.jsx


function Content_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Content_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Content_ownKeys(Object(source), true).forEach(function (key) { Content_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Content_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function Content_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var Content = {
  name: "meg-layout-content",
  render: function render() {
    var h = arguments[0];
    var prefixCls = "meg-layout-content";
    var props = {
      props: Content_objectSpread({}, this.$attrs)
    };
    return h(Wrapper, babel_helper_vue_jsx_merge_props_default()([props, {
      "class": "".concat(prefixCls)
    }]), [this.$slots.default]);
  }
};
/* harmony default export */ var layout_Content = (Content);
// CONCATENATED MODULE: ./src/components/layout/Container.jsx


function Container_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Container_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Container_ownKeys(Object(source), true).forEach(function (key) { Container_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Container_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function Container_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


/* harmony default export */ var Container = ({
  name: 'meg-layout-container',
  render: function render() {
    var h = arguments[0];
    var props = {
      props: Container_objectSpread({
        height: "100vh"
      }, this.$attrs)
    };
    return h(Wrapper, babel_helper_vue_jsx_merge_props_default()([props, {
      "class": "meg-layout-container"
    }]), [this.$slots.default]);
  }
});
// CONCATENATED MODULE: ./src/components/layout/Main.jsx


function Main_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Main_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Main_ownKeys(Object(source), true).forEach(function (key) { Main_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Main_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function Main_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var Main_Content = {
  name: "meg-layout-main",
  render: function render() {
    var h = arguments[0];
    var prefixCls = "meg-layout-main";
    var props = {
      props: Main_objectSpread({}, this.$attrs)
    };
    return h(Wrapper, babel_helper_vue_jsx_merge_props_default()([props, {
      "class": "".concat(prefixCls)
    }]), [this.$slots.default]);
  }
};
/* harmony default export */ var Main = (Main_Content);
// CONCATENATED MODULE: ./src/components/layout/index.jsx






 // import "./style/index.scss";

Wrapper.install = function (Vue) {
  Vue.component(Wrapper.name, Wrapper);
  Vue.component(layout_Header.name, layout_Header);
  Vue.component(layout_Footer.name, layout_Footer);
  Vue.component(layout_Sider.name, layout_Sider);
  Vue.component(layout_Content.name, layout_Content);
  Vue.component(Container.name, Container);
  Vue.component(Main.name, Main);
};

/* harmony default export */ var layout = __webpack_exports__["default"] = (Wrapper);

/***/ })

}]);